import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Coffee = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 81 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="Frame" clipPath="url(#clip0_2982_24113)">
        <g id="Group">
          <g id="Vector">
            <path
              d="M72.0414 57.5369V11.3034C72.0414 7.79592 69.1716 4.92639 65.6645 4.92639H8.27156C4.76406 4.92639 1.89453 7.79608 1.89453 11.3034V62.3194C1.89453 65.8265 4.76406 68.6962 8.27156 68.6962H50.0413"
              fill="white"
              fillRule="evenodd"
              clipRule="evenodd"
            />
            <path
              d="M72.0414 57.5369V11.3034C72.0414 7.79592 69.1716 4.92639 65.6645 4.92639H8.27156C4.76406 4.92639 1.89453 7.79608 1.89453 11.3034V62.3194C1.89453 65.8265 4.76406 68.6962 8.27156 68.6962H50.0413"
              stroke="#686869"
              strokeWidth="2"
              strokeMiterlimit="22.9256"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            id="Vector_2"
            d="M18.7123 39.424C18.7123 41.222 19.7948 42.767 21.3436 43.4432C17.3409 44.2554 14.3281 47.7939 14.3281 52.0362V53.7101H31.865V52.0362C31.865 47.7939 28.8522 44.2554 24.8495 43.4432C26.3983 42.7668 27.4808 41.222 27.4808 39.424C27.4808 37.0026 25.518 35.0398 23.0967 35.0398C20.6753 35.04 18.7123 37.0028 18.7123 39.424Z"
            fill="#CCE7FE"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            id="Vector_3"
            d="M2.69141 19.2746H22.6195C26.5653 19.2746 29.7936 16.0464 29.7936 12.1006H71.2441M8.27109 12.1006H8.27234M15.4452 12.1006H15.4464M22.6192 12.1006H22.6205M54.5841 26.4486H44.3011M64.867 33.4634H44.3011M37.127 61.5221H9.06828M9.06828 26.4487H37.127V54.5075H9.06828V26.4487Z"
            stroke="#686869"
            strokeWidth="2"
            strokeMiterlimit="22.9256"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_4"
            d="M58.8086 47.9714V75.0736H73.9539C77.4614 75.0736 80.3309 72.2041 80.3309 68.6966V59.131C80.3309 57.3772 78.8961 55.9425 77.1425 55.9425H66.7798V54.3485C66.7798 50.8411 63.9102 47.9714 60.4028 47.9714H58.8086Z"
            fill="#CCE7FE"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            id="Vector_5"
            d="M50.8398 59.1311H58.8111V75.0736H50.8398V59.1311Z"
            fill="white"
            stroke="#686869"
            fillRule="evenodd"
            clipRule="evenodd"
            strokeWidth="2"
            strokeMiterlimit="22.9256"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2982_24113">
          <rect width="80" height="80" fill="white" transform="translate(0.332031)" />
        </clipPath>
      </defs>
    </svg>
  );
};

Coffee.displayName = 'Coffee';
